const { createRecipeTiles } = require('../shop/tiles/recipe-tile-factory');

class SearchRecipeTileListController {
    constructor(settings, searchService, sortByKeys) {
        this.settings = settings;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.searchService.doSearchRecipes(this.searchTerm, pageSize, pageNumber, sortType)
            .then(tiles => this.createTiles(tiles));
    }
}

SearchRecipeTileListController.$inject = ['Settings', 'SearchService', 'SortByKeys'];

const searchRecipeTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: SearchRecipeTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchRecipeTileListController,
    searchRecipeTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-recipe-tile-list.component.js